/** @format */
// Migrated from AngularJS: profile.component.js
import { Component, ViewEncapsulation } from '@angular/core';

// Default change detection: this is a routing shell whose only job is to host <ui-view> transitions.
// UI Router instantiates leaf components outside the OnPush dirty-check path, so OnPush leaves the
// shell rendered blank until the next NgZone tick. The project's other ui-view hosts also use the
// default strategy (see e.g. PaymentAndGrantTabsComponent, SearchTabsComponent).
@Component({
    selector: 'app-profile-shell',
    templateUrl: './profile-shell.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class ProfileShellComponent {}
